import Vue from 'vue';
import axios from 'axios';

Vue.use(axios)
window.axios = axios;
